const endpoint = "https://rvpb3.cuba-games.com"
const cpoint = "https://central-backend.cuba-lv.com"
const mediapoint = cpoint
const gamePlace = { studio: "bishkek", room: "po-room" } // tbilisi, bishkek
const name = "Vip Russian Poker"
const number = 3

export { endpoint, cpoint, mediapoint, gamePlace, name, number }
